// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
// const awsmobile = {
//     'aws_app_analytics': 'enable',
//     'aws_cloud_logic': 'enable',
//     'aws_cloud_logic_custom': [{"id":"v413r9q43g","name":"Top10Deals","description":"the current top ten lease deals","endpoint":"https://v413r9q43g.execute-api.us-east-1.amazonaws.com/Development","region":"us-east-1","paths":["/items","/items/123"]},{"id":"basg90yzuk","name":"leasy","description":"","endpoint":"https://ccsracr5z1.execute-api.us-east-1.amazonaws.com/dev","region":"us-east-1","paths":["/deals"]}],
//     'aws_cognito_identity_pool_id': 'us-east-1:57d18f54-d516-41db-a5f3-16f9bf76b67e',
//     'aws_cognito_region': 'us-east-1',
//     'aws_content_delivery': 'enable',
//     'aws_content_delivery_bucket': 'leasy-hosting-mobilehub-602766458',
//     'aws_content_delivery_bucket_region': 'us-east-1',
//     'aws_content_delivery_cloudfront': 'enable',
//     'aws_content_delivery_cloudfront_domain': 'd2dqz61ndf469s.cloudfront.net',
//     'aws_dynamodb': 'enable',
//     'aws_dynamodb_all_tables_region': 'us-east-1',
//     'aws_dynamodb_table_schemas': [{"tableName":"leasy-mobilehub-602766458-Leasy-Notes","attributes":[{"name":"userId","type":"S"},{"name":"creationDate","type":"N"},{"name":"content","type":"S"},{"name":"noteId","type":"S"},{"name":"title","type":"S"}],"indexes":[{"indexName":"DateSorted","hashKey":"userId","rangeKey":"creationDate"}],"region":"us-east-1","hashKey":"userId","rangeKey":"creationDate"}],
//     'aws_mobile_analytics_app_id': '560bdb7a96e349469d66f303cc53c4ce',
//     'aws_mobile_analytics_app_region': 'us-east-1',
//     'aws_project_id': 'd0a9bc7b-9d2f-42c2-b22b-41826a1c387f',
//     'aws_project_name': 'Leasy',
//     'aws_project_region': 'us-east-1',
//     'aws_resource_bucket_name': 'leasy-deployments-mobilehub-602766458',
//     'aws_resource_name_prefix': 'leasy-mobilehub-602766458',
//     'aws_sign_in_enabled': 'enable',
//     'aws_user_pools': 'enable',
//     'aws_user_pools_id': 'us-east-1_q3OCMTMkF',
//     'aws_user_pools_mfa_type': 'OFF',
//     'aws_user_pools_web_client_id': '5i7rn8rmplqr9k2cmsn40ks3jl',
// }

const awsmobile = {
    'aws_cloud_logic_custom': [{"id":"v413r9q43g","name":"ipdata","description":"the current top ten lease deals","endpoint":"https://cors-anywhere.herokuapp.com/https://api.ipdata.co","region":"us-east-1","paths":["/items","/items/123"]},{"id":"basg90yzuk","name":"leasy","description":"","endpoint":"https://ccsracr5z1.execute-api.us-east-1.amazonaws.com/dev","region":"us-east-1","paths":["/deals"]}],
    //'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'us-east-1:0766f42a-d106-404c-826c-ddad1a6ed9d8',
    'aws_cognito_region': 'us-east-1',
    // 'aws_mobile_analytics_app_id': 'e30311af541c467fbb0470cb2639cd97',
    // 'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': 'd1cd99fe-bf84-408a-a001-f94f45514738',
    'aws_project_name': 'hipkar-v1',
    'aws_project_region': 'us-east-1',
    'aws_resource_name_prefix': 'hipkarv-mobilehub-1612180980',
    'aws_sign_in_enabled': 'enable',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_PzCTO0GN8',
    'aws_user_pools_mfa_type': 'OFF',
    'aws_user_pools_web_client_id': '6kua1on9qflo8g3gq7ctbe07us',
}

export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js